export default {
  "projets": {
    "heroTitle": "Nos Projets Réalisés",
    "heroSubtitle": "Découvrez nos réalisations à travers l'Afrique : plus de 1000 projets dans 6 pays",
    "stats": {
      "projects": "Projets réalisés",
      "countries": "Pays",
      "capacity": "Capacité installée"
    },
    "filters": {
      "categoryLabel": "Catégorie",
      "regionLabel": "Région",
      "resultsCount": "{{count}} projet{{plural}} trouvé{{plural}}",
      "categories": {
        "tous": "Tous les projets",
        "micro-reseaux": "Micro-réseaux",
        "industriel": "Industriel",
        "residentiel": "Résidentiel",
        "telecoms": "Télécommunication",
        "btp": "Génie Civil & BTP",
        "medical": "Médical"
      },
      "regions": {
        "toutes": "Toutes les régions",
        "afrique": "Afrique",
        "asie": "Asie",
        "ameriques": "Amériques",
        "europe": "Europe"
      }
    },
    "photoGallery": {
      "badge": "Galerie",
      "title": "Photos de Nos Chantiers",
      "subtitle": "Images réelles de nos installations et interventions sur le terrain. Cliquez pour agrandir.",
      "categories": {
        "tous": "Tous les chantiers",
        "genie-civil": "Génie Civil",
        "btp": "BTP & Construction",
        "installation-electrique": "Installation Électrique",
        "montage-solaire": "Montage Solaire"
      },
      "emptyState": "Aucune photo dans cette catégorie"
    },
    "projectCard": {
      "capacity": "Capacité:",
      "beneficiaries": "Bénéficiaires:",
      "duration": "Durée:",
      "partners": "Partenaires:"
    },
    "emptyState": {
      "title": "Aucun projet trouvé",
      "description": "Essayez de modifier vos filtres pour voir plus de résultats."
    },
    "cta": {
      "title": "Votre projet est le prochain ?",
      "subtitle": "Rejoignez nos clients satisfaits et bénéficiez de notre expertise pour votre projet d'énergie renouvelable.",
      "quoteBtn": "Demander un devis",
      "contactBtn": "Nous contacter"
    },
    "list": [
      {
        "titre": "Micro-réseau Rural Zambie",
        "description": "Installation complète de micro-réseau pour électrification de 12 villages ruraux avec système de gestion intelligente et stockage par batteries lithium.",
        "details": { "beneficiaires": "15,000 habitants", "duree": "18 mois", "partenaires": "Banque Mondiale, Gouvernement de Zambie" }
      },
      {
        "titre": "Complexe Industriel Mali",
        "description": "Système hybride solaire-réseau pour zone industrielle avec optimisation énergétique et réduction de 60% des coûts électriques.",
        "details": { "beneficiaires": "50 entreprises", "duree": "24 mois", "partenaires": "Gouvernement du Mali, Banque Africaine de Développement" }
      },
      {
        "titre": "Campus Universitaire Sénégal",
        "description": "Installation solaire avec stockage pour campus universitaire, incluant bornes de recharge pour véhicules électriques.",
        "details": { "beneficiaires": "25,000 étudiants", "duree": "12 mois", "partenaires": "Université Cheikh Anta Diop, Ministère de l'Énergie du Sénégal" }
      },
      {
        "titre": "Hôpital Rural Tanzanie",
        "description": "Système d'urgence solaire pour centre médical avec alimentation continue et backup automatique.",
        "details": { "beneficiaires": "50,000 patients/an", "duree": "8 mois", "partenaires": "OMS, Ministère de la Santé de Tanzanie" }
      },
      {
        "titre": "Réseau Télécoms Bénin",
        "description": "Alimentation solaire pour 50 sites de télécommunication avec monitoring centralisé.",
        "details": { "beneficiaires": "2 millions d'abonnés", "duree": "15 mois", "partenaires": "Opérateurs de télécommunication, ARCEP Bénin" }
      },
      {
        "titre": "Mini-Grid Togo",
        "description": "Micro-réseau communautaire pour 8 villages avec système de paiement mobile.",
        "details": { "beneficiaires": "12,000 habitants", "duree": "20 mois", "partenaires": "Banque Africaine de Développement, FAO" }
      },
      {
        "titre": "Ferme Solaire Bénin",
        "description": "Grande ferme solaire connectée au réseau national avec technologie de suivi solaire.",
        "details": { "beneficiaires": "100,000 foyers", "duree": "30 mois", "partenaires": "ARCEP Bénin, Banque Européenne d'Investissement" }
      },
      {
        "titre": "Centre Commercial Sénégal",
        "description": "Installation solaire sur toiture avec autoconsommation et revente du surplus.",
        "details": { "beneficiaires": "50,000 visiteurs/jour", "duree": "6 mois", "partenaires": "Dakar Trade Center, APIX Sénégal" }
      },
      {
        "titre": "Mine d'Or Mali",
        "description": "Système hybride solaire-diesel pour exploitation minière avec réduction de 40% de la consommation de carburant.",
        "details": { "beneficiaires": "2,000 employés", "duree": "18 mois", "partenaires": "Compagnie minière, IFC" }
      },
      {
        "titre": "Hôpital Régional Sénégal",
        "description": "Système solaire de secours pour hôpital régional avec onduleurs médicaux certifiés.",
        "details": { "beneficiaires": "200,000 patients/an", "duree": "10 mois", "partenaires": "Ministère de la Santé du Sénégal, Coopération Française" }
      },
      {
        "titre": "Université Technologique Togo",
        "description": "Campus solaire intelligent avec système de gestion énergétique et laboratoires de recherche.",
        "details": { "beneficiaires": "30,000 étudiants", "duree": "14 mois", "partenaires": "Université de Lomé, UNESCO" }
      },
      {
        "titre": "Réseau Télécoms Bénin — Extension",
        "description": "Alimentation solaire pour infrastructure 4G/5G avec batteries de secours haute capacité.",
        "details": { "beneficiaires": "5 millions d'abonnés", "duree": "12 mois", "partenaires": "MTN Bénin, ARTCI" }
      },
      {
        "titre": "Fondations Pylônes MTN — Bénin",
        "description": "Réalisation de 120 fondations en béton armé pour pylônes de télécommunication autostables et haubanés. Terrassement, ferraillage, coffrage et coulage sur 15 sites répartis dans tout le pays.",
        "details": { "beneficiaires": "3 millions d'abonnés", "duree": "10 mois", "partenaires": "MTN Bénin, Huawei" }
      },
      {
        "titre": "Charpente Métallique Industrielle — Sénégal",
        "description": "Fabrication et montage de 850 tonnes de charpentes métalliques pour un entrepôt logistique de 12 000 m². Poutres treillis, pannes, contreventements et bardage double peau.",
        "details": { "beneficiaires": "500 emplois créés", "duree": "14 mois", "partenaires": "Groupe industriel sénégalais, Ericsson" }
      },
      {
        "titre": "Fondations Télécoms — Mali",
        "description": "Réalisation de 200 fondations de pylônes de télécommunication en zone rurale. Études géotechniques, fondations superficielles et profondes, massifs de mise à la terre.",
        "details": { "beneficiaires": "1.5 million d'abonnés", "duree": "8 mois", "partenaires": "Orange Mali, Nokia" }
      },
      {
        "titre": "Data Center — Sénégal",
        "description": "Construction clé en main d'un data center de 3 200 m² incluant gros œuvre, charpente métallique, étanchéité, lots techniques et système de refroidissement redondant.",
        "details": { "beneficiaires": "Opérateurs régionaux", "duree": "18 mois", "partenaires": "Sonatel, Huawei Technologies" }
      }
    ]
  }
};